// icons
import { 
  MdAnalytics, 
  MdTrendingUp, 
  MdAttachMoney, 
  MdAccountBalanceWallet, 
  MdDashboard,
  MdBarChart, 
  MdAccountBalance, 
  MdTrendingDown,
  MdWarning
} from "react-icons/md";

const reportesAnalisis = {
    id: 'reportes-analisis-group',
    type: 'group',
    roles: [1,100,110,400],
    breadcrumbs: false,
    children: [
      {
        id: 'reportes-analisis',
        title: "Reportes y Análisis",
        type: 'collapse',
        icon: MdAnalytics,
        children: [
          {
            id: 'reportes-ventas',
            title: "Reportes de Ventas",
            type: 'item',
            breadcrumbs: false,
            icon: MdTrendingUp,
            roles: [1,100,110,400],
            url: '/reportes-analisis/reportes-ventas'
          },
          {
            id: 'comisiones-vendedores',
            title: "Comisiones de Vendedores",
            type: 'item',
            breadcrumbs: false,
            icon: MdAttachMoney,
            roles: [1,100,110,400],
            url: '/reportes-analisis/comisiones-vendedores'
          },
          {
            id: 'analisis-cartera',
            title: "Análisis de Cartera",
            type: 'item',
            breadcrumbs: false,
            icon: MdAccountBalanceWallet,
            roles: [1,100,110,400],
            url: '/reportes-analisis/analisis-cartera'
          },
          {
            id: 'dashboard-comercial',
            title: "Dashboard Comercial",
            type: 'item',
            breadcrumbs: false,
            icon: MdDashboard,
            roles: [1,100,110,400],
            url: '/reportes-analisis/dashboard-comercial'
          },
          {
            id: 'ventas-montos',
            title: "Ventas Totales",
            type: 'item',
            breadcrumbs: false,
            icon: MdBarChart,
            roles: [1,100,110,400],
            url: '/reportes/ventas-montos'
          },
          {
            id: 'ventas-unidades',
            title: "Ventas por Unidades",
            type: 'item',
            breadcrumbs: false,
            icon: MdBarChart,
            roles: [1,100,110,400],
            url: '/reportes/ventas-unidades'
          },
          {
            id: 'ventas-modelo',
            title: "Ventas por Modelo",
            type: 'item',
            breadcrumbs: false,
            icon: MdBarChart,
            roles: [1,100,110,400],
            url: '/reportes/ventas-modelo'
          },
          {
            id: 'gastos-mensuales',
            title: "Gastos Mensuales",
            type: 'item',
            breadcrumbs: false,
            icon: MdTrendingDown,
            roles: [1,100,110,400],
            url: '/reportes/gastos-mensuales'
          },
          {
            id: 'gastos-categorias',
            title: "Gastos por Categorías",
            type: 'item',
            breadcrumbs: false,
            icon: MdTrendingDown,
            roles: [1,100,110,400],
            url: '/reportes/gastos-categorias'
          },
          {
            id: 'estado-resultados',
            title: "Estado de Resultados",
            type: 'item',
            breadcrumbs: false,
            icon: MdAccountBalance,
            roles: [1,100,110,400],
            url: '/reportes/estado-resultados'
          },
          {
            id: 'backorders',
            title: "Back Order",
            type: 'item',
            breadcrumbs: false,
            icon: MdWarning,
            roles: [1,100,110,400],
            url: '/reportes/backorders'
          },
        ]
      }
    ]
  };

export default reportesAnalisis;